import { AbstractControl, ValidatorFn } from '@angular/forms';
import { ErrorMessage } from '../constants/error-message.constants';

export function exactLengthValidator(length: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (control.value && control.value.length !== length) {
            return {
                exactLength: { message: ErrorMessage.exactLength(length) }
            };
        }

        return null;
    };
}

export function minLengthValidator(length: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (control.value && control.value.length < length) {
            return {
                minLength: { message: ErrorMessage.minLength(length) }
            };
        }

        return null;
    };
}

export function maxLengthValidator(length: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (control.value && control.value.length > length) {
            return {
                maxLength: { message: ErrorMessage.maxLength(length) }
            };
        }

        return null;
    };
}

export function matchValueSourceValidator(
    getOther: () => AbstractControl | undefined,
    customMessage?: string
): ValidatorFn {
    const message = customMessage ?? ErrorMessage.match;
    return (first: AbstractControl): { [key: string]: any } | null => {
        const other = getOther();
        const errors =
            other?.value && first.value !== other?.value ? { matchField: { message } } : null;
        if (errors && other?.valid) {
            other?.setErrors(errors);
        } else if (!errors && !!other?.errors?.matchField) {
            other?.setErrors(errors);
        }
        return null;
    };
}

export function matchValueConfirmValidator(
    getOther: () => AbstractControl | undefined,
    customMessage?: string
): ValidatorFn {
    const message = customMessage ?? ErrorMessage.match;
    return (first: AbstractControl): { [key: string]: any } | null => {
        const other = getOther();
        const errors =
            other?.value && first.value !== other?.value ? { matchField: { message } } : null;
        return errors;
    };
}

export function notMatchValueValidator(
    getValueToCompare: () => string,
    message?: string
): ValidatorFn {
    const errorMessage = !!message ? message : ErrorMessage.different;
    return (control: AbstractControl): { [key: string]: any } | null => {
        const fieldToMatch = getValueToCompare();
        const currentValue = control.value;
        if (fieldToMatch === currentValue) {
            return {
                matchField: { message: errorMessage }
            };
        }
        return null;
    };
}

export function jsonValidator(control: AbstractControl): { [key: string]: any } | null {
    if (control.value === '') {
        return null;
    }
    try {
        JSON.parse(control.value);
    } catch (_e) {
        return {
            badJson: { message: ErrorMessage.json }
        };
    }
    return null;
}

export function textareaValidator(): ValidatorFn {
    return null;
}

export function fullNameValidator(control: AbstractControl): { [key: string]: any } | null {
    if (control.value && !/^\w+(\s\w+)+$/.test(control.value)) {
        return {
            notFullName: { message: ErrorMessage.fullName }
        };
    }

    return null;
}
